import PricingCatalogsWorkspace from "./PricingCatalogsWorkspace";

export default PricingCatalogsWorkspace;
